import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import bus from '@/utils/bus'
import '../public/static/css/common.css'
import '../public/static/css/elementUI.less'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$bus = bus

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
